import { Button, Collapse, Descriptions, Divider, Form, InputNumber, List, Row, Space } from "antd";
import { useListar } from "../../../../../../../../Services/Financeiro/Faturamento/Imposto/Configuracao/ParametroServices";
import { EnumRegimeTributario } from "../../../../../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";
import { EnumGrupoTributario } from "../../../../../../../../Models/Financeiro/Faturamento/Imposto/GrupoTributario";
import { PlusOutlined } from "@ant-design/icons";
import ValorFormBasic from "../ValorFormBasic";
import ValorListBasic from "../ValorListBasic";
import ValorServico from "../../../../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor/ValorServico";
import ValorGrupo from "../../../../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor/ValorGrupo";
import Valor from "../../../../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor";

interface IValorServicoFormProps<T> {
    codRegimeTributario:EnumRegimeTributario;
    nomeRegimeTributario:string;
    codGrupoTributario:EnumGrupoTributario;
    value?:ValorGrupo<T>[];
    onChange?:(valorServico:ValorGrupo<T>[]) => void;
}
export default function ValorServicoFormBasic<T>({
    nomeRegimeTributario,
    codRegimeTributario,
    codGrupoTributario,
    value,
    onChange
}:IValorServicoFormProps<T>) {
    const {
        data,
        isPending,
        isSuccess
    } = useListar({
        codRegimeTributario,
        codGrupoTributario
    });
    function adicionarValor (codParametro:number, valor:Valor) {
        valor.codRegimeTributario = codRegimeTributario;
        valor.codParametro = codParametro;

        onChange?.(
            [
                ...(value ?? []),
                {
                    codigo : 0,
                    valor : valor,
                    codValor : 0,
                    ativo : true,
                    codEntidade : 0
                } as ValorGrupo<T>
            ]
        );
    }
    function removeValor (valor:Valor) {
        onChange?.(
            (value ?? []).filter(f => 
                !(f.valor?.codParametro == valor.codParametro
                && f.valor?.codRegimeTributario == valor.codRegimeTributario
                && f.valor?.dataInicial.getFullYear() == valor.dataInicial.getFullYear()
                && f.valor?.dataInicial.getMonth() == valor.dataInicial.getMonth()
                && f.valor?.dataInicial.getDate() == valor.dataInicial.getDate())
            )
        );
    }
    return <List
        itemLayout="vertical"
        header={nomeRegimeTributario}
        dataSource={data}
        loading={isPending}
        rowKey={({ codigo }) => codigo}
        bordered
        renderItem={({impostoTipo, incidencia, parametroTipo, codigo}, index) => {
            return <Descriptions bordered size="middle">
                <Descriptions.Item label="Imposto" span={24}>{impostoTipo?.nome}</Descriptions.Item>
                <Descriptions.Item label="Tipo" span={24}>{parametroTipo?.nome}</Descriptions.Item>
                <Descriptions.Item label="Incidência" span={24}>{incidencia?.nome}</Descriptions.Item>
                <Descriptions.Item label="Valores" span={24}>
                    <>
                        <ValorFormBasic adicionar={(valor) => adicionarValor(codigo, valor)} adicionarDepois={"%"}/>
                        <ValorListBasic 
                            valores={(value ?? []).filter(f => f.valor !== null && f.valor?.codParametro === codigo && f.valor.codRegimeTributario == codRegimeTributario).map(m => m.valor) as Valor[]}
                            remove={removeValor}
                        />
                    </>
                </Descriptions.Item>
            </Descriptions>;
        }}
    ></List>
}